// Статусы абонементов для селекта

export const subscriptionsStatusData = [
	{ value: 'NEW', label: 'Новый' },
	{ value: 'ACTIVE', label: 'Активный' },
	{ value: 'BLOCKED', label: 'Аннулирован' },
];